import "ace-builds/src-noconflict/ext-language_tools";

const latexCompleter = {
    getCompletions: function (editor, session, pos, prefix, callback) {
        const text = session.getValue();
        const line = session.getLine(pos.row);
        const col = pos.column;

        const beforeCursor = line.slice(0, col);
        const refMatch = beforeCursor.match(/\\(ref|cite)\{[^}]*$/);

        if (!refMatch) {
            callback(null, []); // Not in \ref{ or \cite{
            return;
        }
        const command = refMatch[1];
        const labels = [];
        const labelRegex = /\\label\{([^}]+)\}/g;
        let match;
        while ((match = labelRegex.exec(text)) !== null) {
            labels.push(match[1]);
        }
        const bibitems = [];
        const bibRegex = /\\bibitem\{([^}]+)\}/g;
        while ((match = bibRegex.exec(text)) !== null) {
            bibitems.push(match[1]);
        }
        const suggestions = command === "ref" ? labels : bibitems;

        // Filter by prefix (optional)
        const filtered = suggestions.filter(s => s.startsWith(prefix));

        const completions = filtered.map(s => ({
            caption: s,
            value: s,
            meta: command === "ref" ? "label" : "bibitem"
        }));

        callback(null, completions);
    }
};

export function setupLatexAutocomplete(aceRef) {
    if (!aceRef?.current?.editor) return;
    const editor = aceRef.current.editor;

    // **Merge your completer with prebuilt word completers**
    editor.completers = (editor.completers || []).concat(latexCompleter);
}
